import { Button } from '@aitoken/ui/components/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from '@aitoken/ui/components/dropdown-menu';
import { cn } from '@aitoken/ui/lib/utils';
import { Monitor, Moon, Sun, type LucideIcon } from 'lucide-react';
import { setThemePref, THEME_LABEL, THEME_PREFS, useThemePref, type ThemePref } from '@/lib/theme';

const THEME_ICON: Record<ThemePref, LucideIcon> = { light: Sun, dark: Moon, system: Monitor };

/** 顶栏的主题切换：图标按钮 + 下拉（浅色 / 深色 / 跟随系统） */
export function ThemeMenu({ className }: { className?: string }) {
  const pref = useThemePref();
  const Icon = THEME_ICON[pref];
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className={cn('size-9 rounded-full text-muted-foreground hover:text-foreground', className)}
          aria-label={`外观：${THEME_LABEL[pref]}`}
        >
          <Icon className="size-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-36">
        <DropdownMenuLabel className="text-[13px] font-normal text-muted-foreground">外观</DropdownMenuLabel>
        <DropdownMenuRadioGroup value={pref} onValueChange={(v) => setThemePref(v as ThemePref)}>
          {THEME_PREFS.map((p) => {
            const I = THEME_ICON[p];
            return (
              <DropdownMenuRadioItem key={p} value={p}>
                <I className="size-4" />
                {THEME_LABEL[p]}
              </DropdownMenuRadioItem>
            );
          })}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
